import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const VaultToolbar = ({ 
  searchQuery, 
  onSearchChange, 
  selectedItems, 
  onBulkAction, 
  onCreateItem,
  onViewToggle,
  viewMode 
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedType, setSelectedType] = useState('all');
  const [selectedTag, setSelectedTag] = useState('all');
  const [sortBy, setSortBy] = useState('modified');

  const itemTypes = [
    { value: 'all', label: 'All Types' },
    { value: 'password', label: 'Passwords' },
    { value: 'api-key', label: 'API Keys' },
    { value: 'ssh-key', label: 'SSH Keys' },
    { value: 'database', label: 'Database' },
    { value: 'secure-note', label: 'Secure Notes' }
  ];

  const tags = [
    { value: 'all', label: 'All Tags' },
    { value: 'production', label: 'Production' },
    { value: 'development', label: 'Development' },
    { value: 'staging', label: 'Staging' },
    { value: 'critical', label: 'Critical' },
    { value: 'shared', label: 'Shared' }
  ];

  const sortOptions = [
    { value: 'modified', label: 'Last Modified' },
    { value: 'created', label: 'Date Created' },
    { value: 'name', label: 'Name A-Z' },
    { value: 'type', label: 'Item Type' },
    { value: 'strength', label: 'Password Strength' }
  ];

  const bulkActions = [
    { value: 'move', label: 'Move to Folder', icon: 'FolderOpen' },
    { value: 'tag', label: 'Add Tags', icon: 'Tag' },
    { value: 'share', label: 'Share Items', icon: 'Share2' },
    { value: 'export', label: 'Export Items', icon: 'Download' },
    { value: 'delete', label: 'Delete Items', icon: 'Trash2' }
  ];

  return (
    <div className="bg-card border-b border-border">
      <div className="p-4">
        {/* Main Toolbar */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4 flex-1">
            {/* Search */}
            <div className="relative flex-1 max-w-md">
              <Icon
                name="Search"
                size={16}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
              />
              <Input
                type="search"
                placeholder="Search credentials, URLs, notes..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e?.target?.value)}
                className="pl-9"
              />
            </div>

            {/* Filter Toggle */}
            <Button
              variant={showFilters ? "default" : "outline"}
              onClick={() => setShowFilters(!showFilters)}
              iconName="Filter"
              iconPosition="left"
            >
              Filters
            </Button>

            {/* View Toggle */}
            <div className="flex border border-border rounded-lg">
              <Button
                variant={viewMode === 'list' ? "default" : "ghost"}
                size="sm"
                onClick={() => onViewToggle('list')}
                className="rounded-r-none border-r border-border"
              >
                <Icon name="List" size={16} />
              </Button>
              <Button
                variant={viewMode === 'grid' ? "default" : "ghost"}
                size="sm"
                onClick={() => onViewToggle('grid')}
                className="rounded-l-none"
              >
                <Icon name="Grid3X3" size={16} />
              </Button>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-2">
            {selectedItems?.length > 0 && (
              <div className="flex items-center space-x-2 mr-4">
                <span className="text-sm text-muted-foreground">
                  {selectedItems?.length} selected
                </span>
                <Select
                  placeholder="Bulk Actions"
                  options={bulkActions}
                  value=""
                  onChange={(value) => onBulkAction(value)}
                  className="w-40"
                />
              </div>
            )}

            <Button
              variant="default"
              onClick={onCreateItem}
              iconName="Plus"
              iconPosition="left"
            >
              Add Item
            </Button>
          </div>
        </div>

        {/* Filters Panel */}
        {showFilters && (
          <div className="flex items-center space-x-4 p-4 bg-muted rounded-lg">
            <Select
              label="Type"
              options={itemTypes}
              value={selectedType}
              onChange={setSelectedType}
              className="w-40"
            />
            
            <Select
              label="Tags"
              options={tags}
              value={selectedTag}
              onChange={setSelectedTag}
              className="w-40"
            />
            
            <Select
              label="Sort by"
              options={sortOptions}
              value={sortBy}
              onChange={setSortBy}
              className="w-40"
            />

            <Button
              variant="ghost"
              onClick={() => {
                setSelectedType('all');
                setSelectedTag('all');
                setSortBy('modified');
              }}
              className="ml-auto"
            >
              Clear Filters
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VaultToolbar;